export default "__VITE_ASSET__MTvinuLX__"